import * as React from 'react'
import styled from 'styled-components'

import * as S from '../styles'

import * as icons from '../svg/icons'
import { Tooltip } from './Tooltip'

export type SocialShareProps = S.socialShare.SocialShareProps & {
  onShare: (socialMedia: (typeof shareList)[number]['name']) => void
  copyStatus: 'failed' | 'idle' | 'succeeded' | undefined
} & React.HTMLAttributes<HTMLUListElement>

const shareList = [
  {
    name: 'share',
    Icon: icons.Share,
  },
  {
    name: 'facebook',
    Icon: icons.Facebook,
  },
  {
    name: 'pinterest',
    Icon: icons.Pinterest,
  },
  {
    name: 'twitter',
    Icon: icons.Twitter,
  },
  {
    name: 'linkedin',
    Icon: icons.LinkedIn,
  },
] as const

function SocialShareComponent({
  column = false,
  copyStatus,
  onShare,
  ...htmlProps
}: SocialShareProps): React.ReactElement {
  return (
    <S.socialShare.SocialShare column={column} {...htmlProps}>
      {shareList.map((socialMedia) => (
        <S.socialShare.Picto key={socialMedia.name} onClick={() => onShare(socialMedia.name)}>
          {socialMedia.name === 'share' ? (
            <Tooltip
              show={copyStatus === 'succeeded'}
              title="Copié vers le presse-papier"
              placement={column ? 'right' : 'bottom'}
            >
              <socialMedia.Icon size={22} />
            </Tooltip>
          ) : (
            <socialMedia.Icon size={22} />
          )}
        </S.socialShare.Picto>
      ))}
    </S.socialShare.SocialShare>
  )
}

export const SocialShare = styled(SocialShareComponent)``
